/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import clsx from "clsx";
import actions from "../../redux/actions";
import { Col, Row, Space, Image } from "antd";
import { useDispatch, useSelector } from "react-redux";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Button, Typography, TextField, Box, FormControlLabel, Switch } from "@mui/material";
import { NavLink, useParams } from "react-router-dom";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CheckBoxCircle from "../../../../../assets/images/icon_actions/CheckBoxCircle.png";
import { AESDecrypt, AESEncrypt } from "../../../../../helpers/Crypto";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import addressActions from "../../../../Admin/Address/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { customPhoneValidation, emptyValidation } from "../../../../../helpers/validation";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import crudActions from "../../../../CRUD/redux/actions";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import moment from 'moment';
import { toast } from 'react-toastify';

const PaymentDetailsView = (props) => {
    const classes = customStyles();
    const { getData, getLoader, editDetails, editError, editLoader, createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const { areaDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { supplierBankDetails } = useSelector(state => state.purchaseManagementReducer);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [view, setView] = useState(true);
    const [deleteModal, setDeleteModal] = useState(false);
    const [visible, setVisible] = useState(false);
    let { supplierId } = useParams();
    const decryptedId = AESDecrypt(supplierId);
    const [form, setForm] = useState({ 'supplierProfileId': decryptedId });
    const [walletForm, setWalletForm] = useState({ 'supplierProfileId': decryptedId });
    const [walletError, setWalletError] = useState({});
    const [walletId, setWalletId] = useState('');
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const { history } = props;
    const [commonError, setCommonError] = useState(false);
    const [commonWalletError, setCommonWalletError] = useState(false);
    const [checkForm, setCheckForm] = useState('');
    // const [checkLoading, setCheckLoading] = useState(true);

    useEffect(() => {
        if (supplierId === undefined || decryptedId === 0) {
            history.push("/purchase/purchase-management/all-suppliers");
            return true;
        }
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.SUPPLIER_DETAILS_START, url: 'supplierProfile', filter: {
                order: 'id  desc'
            }
        });
        dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "supplierProfile" });

        let filter = { ["and"]: [{ supplierProfileId: decryptedId }] };
        dispatch({
            type: actions.SUPPLIER_BANK_DETAILS_START,
            url: "supplier-bank-details", filter: { where: filter }
        });
        loadTasks();
    }, []);

    const loadTasks = () => {
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'supplier-wallet-details',
            skip: 0,
            filter: {
                where: { ["and"]: [{ supplierProfileId: decryptedId }] }
            }
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return '';
    }

    useEffect(() => {
        if (supplierBankDetails && supplierBankDetails?.length > 0) {
            // if (supplierBankDetails[0]?.stateId) {
            //     dispatch({
            //         type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
            //             where: { "and": [{ stateId: supplierBankDetails[0]?.stateId }] }
            //         }
            //     });
            //     dispatch({
            //         type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
            //             where: { "and": [{ stateId: supplierBankDetails[0]?.stateId }] }
            //         }
            //     });
            // }
            // if (supplierBankDetails[0]?.pincodeId) {
            //     dispatch({
            //         type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
            //             where: { "and": [{ pincodeId: supplierBankDetails[0]?.pincodeId }] }
            //         }
            //     });
            // }
            setForm({ ...supplierBankDetails[0] });
        }
    }, [supplierBankDetails]);


    // useEffect(() => {
    //     if (supplierBankDetails && supplierBankDetails?.length > 0 && checkLoading) {
    //         console.log(supplierBankDetails[0]);
    //         setForm({ ...supplierBankDetails[0] });
    //         setCheckLoading(false);
    //     }
    // }, [pincodeDetails, areaDetails, cityDetails])


    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyAccountName = emptyValidation('Account Name', form.account_name);
        let emptyAccountNumber = emptyValidation('Account Number', form.account_number);
        let emptyBankName = emptyValidation('Bank Name', form.bank_name);
        let emptyIfscCode = emptyValidation('IFSC Code', form.ifsc_code);
        // let emptyPincode = emptyValidation('Pincode', form.pincodeId);
        let emptyState = emptyValidation('State', form.stateId);
        setCommonError('');
        setError({});
        if (emptyAccountName.isValid &&
            emptyAccountNumber.isValid &&
            emptyBankName.isValid &&
            emptyIfscCode.isValid && emptyState.isValid) {
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v != null && v !== ''));
            delete data.business; delete data.id; delete data.updatedByUser; delete data.area;
            delete data.city; delete data.state; delete data.pincode; delete data.country;
            setCheckForm('payment');
            dispatch({
                type: supplierBankDetails?.length > 0 ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "supplier-bank-details",
                title: "Supplier Bank Details",
                id: supplierBankDetails?.length > 0 ? supplierBankDetails[0]?.id : '',
                details: data
            })
        } else {
            setError({
                'account_name': emptyAccountName.errors,
                'account_number': emptyAccountNumber.errors,
                'bank_name': emptyBankName.errors,
                'ifsc_code': emptyIfscCode.errors,
                'state': emptyState.errors,
                //   'pincode': emptyPincode.errors,
            });
        }
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'areaId') {
                // let a = customObject(areaDetails, e);
                // if (a !== '') {
                setForm({
                    ...form,
                    'areaId': e
                });
                //}
            } else if (name === 'pincodeId') {
                let a = customObject(pincodeDetails, e);
                //if (a !== '') {
                setForm({
                    ...form,
                    'areaId': '',
                    'pincodeId': e,
                    'cityId': a?.cityId || '',
                });
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { "and": [{ pincodeId: e }] }
                    }
                });
                dispatch({
                    type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                        where: { "and": [{ pincodeId: e }] }
                    }
                });
                //}
            } else if (name === 'cityId') {
                //let a = customObject(cityDetails, e);
                //if (a !== '') {
                setForm({
                    ...form,
                    'areaId': '',
                    'pincodeId': '',
                    'cityId': e
                });
                // }
            } else if (name === 'stateId') {
                let a = customObject(stateDetails, e);
                //if (a !== '') {
                setForm({
                    ...form,
                    'areaId': '',
                    'pincodeId': '',
                    'cityId': '',
                    'stateId': e,
                    'countryId': a?.countryId || '',
                });
                dispatch({
                    type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                        where: { "and": [{ stateId: e }] }
                    }
                });
                dispatch({
                    type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                        where: { "and": [{ stateId: e }] }
                    }
                });
                //}
            } else if (name === 'countryId') {
                setForm({
                    ...form,
                    'areaId': '',
                    'pincodeId': '',
                    'cityId': '',
                    'stateId': '',
                    'countryId': e,
                });
            } else {
                setForm({
                    ...form,
                    [name]: e,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }


    const handleOpen = (v) => {
        setVisible(v);
        emptyWallertForm();
    }

    const emptyWallertForm = () => {
        setWalletForm({ 'supplierProfileId': decryptedId });
        setWalletError({});
        setWalletId('');
        setCommonWalletError(false);
    }

    const onEdit = (data) => {
        setVisible(true);
        setWalletForm(data);
        setWalletError({});
        setWalletId(data.id);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setWalletForm(data);
        setWalletError({});
        setWalletId(data.id);
    }

    const createWallet = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Name', walletForm.name);
        let emptyWallet = emptyValidation('Wallet ID', walletForm.wallet_id);
        let emptyMobileNumber = customPhoneValidation('Mobile Number', walletForm.mobileNumber);
        setWalletError({});
        setCommonWalletError('');
        if (emptyName.isValid &&
            emptyMobileNumber.isValid && emptyWallet.isValid) {
            delete walletForm.business;
            setCheckForm('wallet');
            dispatch({
                type: walletId !== '' ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "supplier-wallet-details",
                title: "Supplier wallet Details",
                id: walletId,
                details: walletForm
            })
        } else {
            setWalletError({
                'name': emptyName.errors,
                'wallet_id': emptyWallet.errors,
                'mobileNumber': emptyMobileNumber.errors
            });
        }
    }

    const walletChangeHandler = (e) => {
        setWalletForm({ ...walletForm, [e.target.name]: e.target.value });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            // toast(createDetails);
            if (checkForm === 'wallet') {
                handleOpen(false);
                loadTasks();
            } else {
                let filter = { ["and"]: [{ supplierProfileId: decryptedId }] };
                dispatch({
                    type: actions.SUPPLIER_BANK_DETAILS_START,
                    url: "supplier-bank-details", filter: { where: filter }
                });
                //setForm(createData);
                setView(true);
            }
            setCheckForm('');
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            if (checkForm === 'wallet') {
                setCommonWalletError(message);
            } else {
                setCommonError(message);
            }
            setCheckForm('');
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            //toast(editDetails);
            if (checkForm === 'wallet') {
                handleOpen(false);
                loadTasks();
            } else {
                let filter = { ["and"]: [{ supplierProfileId: decryptedId }] };
                dispatch({
                    type: actions.SUPPLIER_BANK_DETAILS_START,
                    url: "supplier-bank-details", filter: { where: filter }
                });
                //setForm(editData);
                setView(true);
            }
            setCheckForm('');
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            if (checkForm === 'wallet') {
                setCommonWalletError(message);
            } else {
                setCommonError(message);
            }
            setCheckForm('');
        }
    }, [editDetails, editError]);

    useEffect(() => {
        if (businessDetails && businessDetails !== '' && stateDetails && stateDetails?.length > 0) {
            if (businessDetails?.stateId) {
                // changeHandler(businessDetails?.stateId, 'stateId');
            }
        }
    }, [businessDetails, stateDetails]);

    const handleEdit = () => {
        if (form?.stateId) {
            dispatch({
                type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                    where: { "and": [{ stateId: form?.stateId }] }
                }
            });
            dispatch({
                type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                    where: { "and": [{ stateId: supplierBankDetails[0]?.stateId }] }
                }
            });
        }
        if (form?.pincodeId) {
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { "and": [{ pincodeId: form?.pincodeId }] }
                }
            });
        }
        setView(false);
    }


    return (
        <React.Fragment>
            <MainHeader {...props} cls={'newImg'} img={PurchaseIcon} title={'Purchase'}
                links={[{ 'label': 'Purchase', 'link': '/purchase' },
                { 'label': 'All Suppliers', 'link': '/purchase/purchase-management/all-suppliers' },
                { 'label': 'Supplier Details', 'link': `/purchase/purchase-management/all-suppliers/${AESEncrypt(decryptedId)}/view` },
                { 'label': 'Payment Details', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Payment Details'}
                    customClass={''}
                    component={
                        <Box
                            className={clsx(classes.removeUnderline, classes.paymentDetails)}
                            component="form"
                            autoComplete='off'
                            onSubmit={(e) => handleSubmit(e)}>
                            <Row gutter={50}>
                                {
                                    commonError && <Col span={24}><CustomAlert error={commonError} customClass={clsx(classes.uploadError)} /></Col>
                                }
                                {
                                    view ? <>
                                        <Col span={5}>
                                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.customLink, classes.bold)}>Bank Details</Typography>
                                        </Col>
                                        <Col span={19} className={classes.textAlignRight}>
                                            <NavLink to={'#'} onClick={() => handleEdit()} className={clsx(classes.modalBtn, classes.bold, classes.marginRight0)}>Edit</NavLink>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin10t, classes.fonSize13)}>Bank Name</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.bank_name || '---'}</Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin10t, classes.fonSize13)}>Account Name</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.account_name || '---'}</Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin10t, classes.fonSize13)}>Account Number</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.account_number || '---'}</Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin10t, classes.fonSize13)}>IFSC Code</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.ifsc_code || '---'}</Typography>
                                        </Col>
                                        <Col span={4}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin10t, classes.fonSize13)}>Bank Branch</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.branch_name || '---'}</Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Bank Address</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.address || '---'}</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.area?.name || '---'}</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.city?.name || '---'}</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.pincode?.code || '---'}</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.state?.name || '---'}</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.country?.name || '---'}</Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Created Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createTs ? moment(form?.createTs).format('DD MMM YYYY') : '---'}</Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Last Updated Date & Time</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.updateTs ? moment(form?.updateTs).format('DD MMM YYYY - hh:mm A') : '---'} </Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Updated By</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.updatedByUser?.name || '---'}</Typography>
                                        </Col>
                                    </> : <>
                                        <Col span={5}>
                                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}
                                            >Bank Details</Typography>
                                        </Col>
                                        <Col span={19} className={classes.textAlignRight}>
                                            <Button
                                                type='submit'
                                                color='primary'
                                                variant="contained"
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader })}>
                                                Save
                                            </Button>
                                        </Col>
                                        <Col span={5}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Bank Name ", <span key={"Bank Name"} className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                value={form?.bank_name || ''}
                                                className={clsx(classes.margin20t)}
                                                variant={'standard'}
                                                name={'bank_name'}
                                                error={error?.bank_name ? true : false}
                                                helperText={error?.bank_name}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                        </Col>
                                        <Col span={5}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Account Name ", <span key={"Account Name"} className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                name={"account_name"}
                                                value={form?.account_name || ''}
                                                className={clsx(classes.margin20t)}
                                                variant={'standard'}
                                                error={error?.account_name ? true : false}
                                                helperText={error?.account_name}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                        </Col>
                                        <Col span={5}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Account Number ", <span key={"Account Number"} className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                name={"account_number"}
                                                value={form?.account_number || ''}
                                                className={clsx(classes.margin20t)}
                                                variant={'standard'}
                                                error={error?.account_number ? true : false}
                                                helperText={error?.account_number}
                                                onChange={(e) => changeHandler(e)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                            />
                                        </Col>
                                        <Col span={5}>
                                            <TextField autoComplete='one-time-code'
                                                label={["IFSC Code ", <span key={"IFSC Code"} className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                name={"ifsc_code"}
                                                value={form?.ifsc_code || ''}
                                                className={clsx(classes.margin20t)}
                                                error={error?.ifsc_code ? true : false}
                                                helperText={error?.ifsc_code}
                                                onChange={(e) => changeHandler(e)}
                                                variant={'standard'}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                            />
                                        </Col>
                                        <Col span={4}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Bank Branch"]}
                                                fullWidth
                                                name={"branch_name"}
                                                value={form?.branch_name || ''}
                                                error={error?.branch_name ? true : false}
                                                helperText={error?.branch_name}
                                                className={clsx(classes.margin20t)}
                                                variant={'standard'}
                                                onChange={(e) => changeHandler(e)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                            />
                                        </Col>
                                        <Col span={5}>
                                            <AutoCompleteComponent
                                                name={["State/Province ", <span key={"State/Province"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'State Name' },
                                                { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                                details={stateDetails}
                                                parentValue={customObject(stateDetails, form?.stateId)}
                                                onChange={(data) => changeHandler(data.id, 'stateId')}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                                parentError={error?.state}
                                                infoMark={'The value selected in this field defaults from your Business address. Please select the correct State address for the Party record.'}
                                            />
                                        </Col>
                                        <Col span={5}>
                                            <AutoCompleteComponent
                                                name={["Pincode "]}
                                                heads={[{ 'key': 'code', 'name': 'Pincode' },
                                                { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                                details={pincodeDetails}
                                                parentValue={customObject(pincodeDetails, form?.pincodeId)}
                                                onChange={(data) => changeHandler(data.id, 'pincodeId')}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                                parentError={error?.pincode}
                                            />
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Created Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createTs ? moment(form?.createTs).format('DD MMM YYYY') : '---'}</Typography>
                                        </Col>
                                        <Col span={5}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Last Updated Date & Time</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.updateTs ? moment(form?.updateTs).format('DD MMM YYYY - hh:mm A') : '---'}</Typography>
                                        </Col>
                                        <Col span={4}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Updated By</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.updatedByUser?.name || '---'}</Typography>
                                        </Col>
                                        <Col span={10}>
                                            <Row gutter={50}>
                                                <Col span={12}>
                                                    <TextField autoComplete='one-time-code'
                                                        label=''
                                                        value={form.address}
                                                        onChange={(e) => changeHandler(e)}
                                                        placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                        variant={'outlined'}
                                                        className={clsx(classes.margin20t, classes.customDescription)}
                                                        fullWidth
                                                        multiline
                                                        name={"address"}
                                                        rows={6}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            },
                                                            style: { height: 170 },
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColor,
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={12}>
                                                    <AutoCompleteComponent
                                                        name={["Area"]}
                                                        heads={[{ 'key': 'name', 'name': 'Area Name' },
                                                        { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                                        { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                                        { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                                        details={areaDetails}
                                                        parentValue={customObject(areaDetails, form?.areaId)}
                                                        onChange={(data) => changeHandler(data.id, 'areaId')}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                        customLink={'/admin/address/area'}
                                                        linkText={'Go to Area'}
                                                        infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                                    />
                                                    <AutoCompleteComponent
                                                        name={["Dist/City/Town"]}
                                                        heads={[{ 'key': 'name', 'name': 'Name' },
                                                        { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                                        details={cityDetails}
                                                        parentValue={customObject(cityDetails, form?.cityId)}
                                                        onChange={(data) => changeHandler(data.id, 'cityId')}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                    />
                                                    <AutoCompleteComponent
                                                        name={["Country"]}
                                                        heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                                        details={countryDetails}
                                                        parentValue={customObject(countryDetails, form?.countryId)}
                                                        onChange={(data) => changeHandler(data.id, 'countryId')}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </>
                                }

                                <Col span={24}>
                                    <Space className={clsx(classes.customLink, classes.margin30t)}>
                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}
                                        >Digital Wallet Details</Typography>
                                    </Space>
                                </Col>
                                {
                                    getLoader ? <Col span={24}><div className={classes.loadMoreCircle}></div></Col> : (
                                        <>
                                            {
                                                getData !== '' && getData?.length > 0 && getData.map((data, i) => (
                                                    <Col span={10}>
                                                        <div className={clsx(classes.border, classes.margin30t)}>
                                                            <div className={clsx(classes.walletHeader)}>
                                                                <Row align="middle">
                                                                    <Col span="12">
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Wallet Name</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{data?.name}</Typography>
                                                                    </Col>
                                                                    <Col span="12" className={classes.textAlignRight}>
                                                                        <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                                <Image
                                                                                    src={EditIcon}
                                                                                    preview={false}
                                                                                />
                                                                            </NavLink>
                                                                            <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                                <Image
                                                                                    src={DeleteIcon}
                                                                                    preview={false}
                                                                                />
                                                                            </NavLink>
                                                                        </Space>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                            <div className={clsx(classes.walletBody)}>
                                                                <Row>
                                                                    <Col span="12">
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Mobile Number</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{data?.mobileNumber}</Typography>
                                                                    </Col>
                                                                    <Col span="12" className={classes.textAlignRight}>
                                                                        {
                                                                            data?.default && <Space size={[3, 0]} direction="horizontal" align="center">
                                                                                <Image
                                                                                    className={classes.paymentAntImage}
                                                                                    src={CheckBoxCircle}
                                                                                    preview={false}
                                                                                /> <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.customLink, classes.bold)}
                                                                                >Default Wallet</Typography>
                                                                            </Space>
                                                                        }
                                                                    </Col>
                                                                    <Col span="24">
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Wallet ID</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{data?.wallet_id || '---'}</Typography>
                                                                    </Col>
                                                                    <Col span="18">
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Last Updated Date & Time</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.updateTs ? moment(form?.updateTs).format('DD MMM YYYY - hh:mm A') : '---'} </Typography>
                                                                    </Col>
                                                                    <Col span="6">
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Updated By</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.updatedByUser?.name || '---'}</Typography>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                ))
                                            }
                                        </>
                                    )
                                }
                                <Col span={10}>
                                    <div className={clsx(classes.border, classes.margin30t, classes.addWallet)}>
                                        <div className={clsx(classes.walletHeader)}>
                                            <Row align="middle">
                                                <Col span="24">
                                                    <NavLink
                                                        to={"#"}
                                                        onClick={() => handleOpen(true)}
                                                        className={clsx(classes.margin20r, classes.customLink)}>
                                                        <Image
                                                            src={AddIcon}
                                                            preview={false}
                                                        /> <span className={clsx(classes.addLink, classes.color, classes.bold)}> Add  Wallet</span>

                                                    </NavLink>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className={clsx(classes.walletBody)}>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Box>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen(false)}
                title={`${walletId ? `${view ? 'View' : 'Edit'}` : 'Add'} Wallet`}
                width={"360px"}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createWallet(e)}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                {
                                    commonWalletError && <Col span={24}><CustomAlert error={commonWalletError} customClass={clsx(classes.uploadError)} /></Col>
                                }
                                <Col span={24}>
                                    <TextField autoComplete='one-time-code'
                                        label={["Wallet Name ", <span key={"Wallet Name"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        className={''}
                                        error={walletError.name ? true : false}
                                        helperText={walletError.name}
                                        name={"name"}
                                        fullWidth
                                        value={walletForm.name}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => walletChangeHandler(e)}
                                    />
                                </Col>
                                <Col span={24}>
                                    <TextField autoComplete='one-time-code'
                                        label={["Mobile Number ", <span key={"Mobile Number"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        className={classes.margin20t}
                                        error={walletError.mobileNumber ? true : false}
                                        helperText={walletError.mobileNumber}
                                        name={"mobileNumber"}
                                        fullWidth
                                        value={walletForm.mobileNumber}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => walletChangeHandler(e)}
                                    />
                                </Col>
                                <Col span={24}>
                                    <TextField autoComplete='one-time-code'
                                        label={["Wallet id ", <span key={"Wallet id"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        className={classes.margin20t}
                                        error={walletError.wallet_id ? true : false}
                                        helperText={walletError.wallet_id}
                                        name={"wallet_id"}
                                        fullWidth
                                        value={walletForm.wallet_id}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => walletChangeHandler(e)}
                                    />
                                </Col>
                                <Col span={24}>
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')  // Pass your override css here
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => setWalletForm({ ...walletForm, 'default': !walletForm.default })}

                                        />}
                                        label="Default"
                                        labelPlacement="top"
                                        checked={walletForm.default}
                                        className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    color="primary"
                                    variant="contained"
                                    type={'submit'}
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                    {
                                        walletId ? 'Update & Close' : 'Save & Close'
                                    }
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)}
                id={walletId} loadTasks={() => loadTasks()} name={walletForm?.name} url={'supplier-wallet-details'} title={'Supplier Wallet Details'} visible={deleteModal} />
        </React.Fragment >
    )
}

export default PaymentDetailsView